import { useState } from "react";
import TabsContainer from "components/TabsContainer";
import Tab from "components/Tab";
import JobsTab from "features/carrers/JobsTab";
import ApplicantsTab from "features/carrers/ApplicantsTab";
import JobApplicationsTab from "features/carrers/JobApplicationsTab";
import CreateJobForm from "features/carrers/CreateJobForm";
import SkillsForm from "features/carrers/SkillsForm";
import IconButton from "components/IconButton";
import InputField from "components/InputField";
import { FaSearch } from "react-icons/fa";


const Carrers = () => {
  const [searchTerm, setSearchTerm] = useState<string>("");

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="mt-5">
      <div className="flex justify-end gap-2 mt-4 md:mt-0">
        <IconButton
          url="/careers/question-management"
          name="QBank"
          icon="fas fa-university"
          extraStyles="bg-brand-500 hover:bg-blue-600 text-white"
        />
        <IconButton
          url="/careers/create-job-application"
          name="Create Job Application"
          icon="fas fa-briefcase"
          extraStyles="bg-brand-500 hover:bg-brand-600 dark:bg-brand-400 dark:hover:bg-brand-500 text-white"
        />
      </div>
      <TabsContainer
        headerActions={
          <div className="flex items-center gap-2">
            <div className="relative !w-64">
              <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500 h-4 w-4 z-10 pointer-events-none" />
              <InputField
                id="careers-search"
                type="text"
                placeholder="Search across all tabs..."
                extra="!w-full pl-10"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                style={{ backgroundColor: 'white' }}
                className="!bg-white dark:!bg-navy-800"
              />
            </div>
          </div>
        }
      >
        <Tab isActive={true} title="Jobs" key={1}>
          <JobsTab searchTerm={searchTerm} />
        </Tab>
        <Tab isActive={false} title="Applicants" key={4}>
          <ApplicantsTab searchTerm={searchTerm} />
        </Tab>
        <Tab isActive={false} title="Job Applications" key={5}>
          <JobApplicationsTab searchTerm={searchTerm} />
        </Tab>
        <Tab isActive={false} title="Create Job" key={3}>
          <CreateJobForm />
        </Tab>
        <Tab isActive={false} title="Create Skill" key={3}>
          <SkillsForm />
        </Tab>
      </TabsContainer>
    </div>
  )
}

export default Carrers;
